// extracted by mini-css-extract-plugin
export default {"layout-container":"layout_layout-container__e2xvu","header":"layout_header__pLfi5","content":"layout_content__z23TH"};